export default "__VITE_ASSET__Bxi9OYZs__"